import {
  REQUEST_CP,
  RECEIVE_CP,
  CP_FAILED,
  API_CALL, REQUEST_UPLOAD, RECEIVE_UPLOAD, UPLOAD_FAILED
} from './types';

export const getCreativeProducts = () => ({
  type: API_CALL,
  onRequest: REQUEST_CP,
  onResponse: RECEIVE_CP,
  onError: CP_FAILED,
  responseKey: 'creativeproducts',
  payload: {
    method: 'GET',
    url: '/creativeproducts'
  }
});

export const uploadProducts = () => ({
  type: API_CALL,
  onRequest: REQUEST_UPLOAD,
  onResponse: RECEIVE_UPLOAD,
  onError: UPLOAD_FAILED,
  responseKey: 'upload',
  payload: {
    method: 'PUT',
    url: '/creativeproducts/upload'
  }
});
